import { render } from "./AppModule.vue?vue&type=template&id=3370c6fe"
import script from "./AppModule.vue?vue&type=script&lang=js"
export * from "./AppModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__